import { Component, OnInit } from "@angular/core";
import { AccountsService } from "./accounts.service";
import { UsersService } from "../users/users.service";
import { Router } from "@angular/router";

@Component({
  selector: "edit-account",
  template: require('./createaccount.component.html'),
  styles: [require('./createaccount.component.scss')]
})
export class EditAccountComponent implements OnInit {
  account: any;
  sent: boolean = false;
  responseValues: any[] = [];
  activePanels: string[] = ["details", "users"];
  editMode: boolean = true;
  employers: any[];
  projects: any[];
  projectId: string;
  users: any[];

  constructor(
    private service: AccountsService,
    private usersService: UsersService,
    private router: Router
  ) {}

  ngOnInit() {
    this.account = AccountsService.currentAccount;
    if (typeof this.account !== "undefined") {
      this.service.getEmployers().subscribe((employers) => {
        this.employers = employers;
      });
      if (!this.account.users) {
        this.usersService.getUsers(this.account.id).subscribe((users) => {
          this.users = users;
          this.getProjectMembers();
        });
      } else {
        this.users = this.account.users;
        delete this.account.users;
        this.getProjectMembers();
      }
    } else {
      this.router.navigate(["/accounts"]);
    }
  }

  getProjectMembers() {
    this.service.getProjects().subscribe((projects) => {
      this.projects = projects;
      this.service
        .getProjectMemberList(this.account.project_ids)
        .subscribe((members) => {
          this.users.map((user) => {
            members.map((member) => {
              if (member.user_id === user.id) {
                if (!user.projects) {
                  user.projects = [];
                }
                let project = this.projects.filter((it) => {
                  return it.id === member.project_id;
                })[0];
                user.projects.push({
                  name: project.name,
                  id: project.id,
                  role: member.role
                });
              }
            });
          });
        });
    });
  }

  getProjectName(id: string): string {
    if (!this.projects) {
      return;
    }
    return this.projects.filter((item) => {
      return item.id === id;
    })[0].name;
  }

  removeListItem(field: string, id: string) {
    let array = this.account[field];
    let index = array.indexOf(id);
    if (index > -1) {
      array.splice(index, 1);
    }
  }

  addProject(projectId: string) {
    if (projectId) {
      this.account.project_ids.push(projectId);
      this.projectId = null;
    }
  }

  selectedProjects() {
    if (!this.projects || !this.account) {
      return;
    }
    return this.projects.filter((it) => {
      return this.account.project_ids.indexOf(it.id) > -1;
    });
  }

  isValid(): boolean {
    return (
      !this.sent &&
      this.account.project_ids.length > 0 &&
      this.account.company_id !== ""
    );
  }

  onSubmit() {
    this.activePanels = [];
    if (!this.sent) {
      this.sent = true;
      this.service.editAccount(this.account, this.users).subscribe(
        (account) => {
          this.back();
        },
        (error) => {
          this.sent = false;
          setTimeout(() => {
            this.activePanels = ["details", "users"];
          }, 1);
        }
      );
    }
  }

  back() {
    window.history.back();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/accounts/editaccount.component.ts